import { useEffect, useState } from 'react';
import { createElement, memo } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import Image from '@hfe/max-image';
import ImageBackground from '@hfe/max-imagebackground';
import { navigateTo } from '@max/meituan-uni-navigate';
import dayjs from 'dayjs';
import './index.scss';
import LinearGradient from '@hfe/max-linear-gradient';
import { solarToLunar } from '../../utils/index';
const isMRN = false;
import Sensor from '@max/mbc-sensor';
import { L_MC, L_MV, PlatformType, TYPE } from '../constants';
import { getPlatformType, getSystemType } from '@nibfe/mkt-env-api';
const isNumberReg = /^-?\d*\.?\d+$/;
const BuyTickets = (props) => {
    const { jumpLink, titleUrl, bgImageURL, lunarDateConfig, gregorianDateConfig, buttonConfig } = props?.config;
    const { mcReport, mvReport } = props?._LXReport;
    const [targetDate, setTargetDate] = useState('');
    const [lunchText, setLunchText] = useState('');
    const platformType = getPlatformType();
    const isMT = platformType === PlatformType.mtApp || PlatformType.mtAppWebView;
    const system = getSystemType();
    const isHarmony = system.toLowerCase() === 'harmony';
    const calcDate = () => {
        let LunchText;
        const now = dayjs();
        // 获取 年月数据
        const intervalTime = now.add(props.intervalDays, 'day').format('MM月DD日');
        const targetData = now.add(props.intervalDays, 'day').format('YYYY-MM-DD');
        const year = dayjs(targetData).year();
        const month = dayjs(targetData).month() + 1;
        const date = dayjs(targetData).date();
        // 开售日期的农历: 腊月初六 类似的日期形式
        LunchText = solarToLunar(month, date, year);
        const nextTargetDate = now.add(props.intervalDays + 1, 'day').format('YYYY-MM-DD');
        const tmpDate = dayjs(nextTargetDate);
        // 开售日期的后一天的农历
        const nextTargetText = solarToLunar(tmpDate.month() + 1, tmpDate.date(), tmpDate.year());
        if (LunchText.startsWith('腊月') && nextTargetText.startsWith('正月')) {
            LunchText = '除夕';
        }
        setLunchText(LunchText);
        setTargetDate(intervalTime + '车票');
    };
    const handleAppera = () => {
        mvReport(L_MV, {
            valLab: {
                type: TYPE.RESERVATION
            }
        });
    };
    const handleClick = () => {
        mcReport(L_MC, {
            valLab: {
                type: TYPE.RESERVATION
            }
        });
        if (jumpLink) {
            if (isMT) {
                navigateTo({
                    url: jumpLink,
                    _web: {
                        miniProgramNative: true
                    }
                });
            }
            else {
                navigateTo({
                    url: `https://w.dianping.com/cube/evoke/meituan.html?url=${encodeURIComponent(jumpLink)}`,
                    _web: {
                        miniProgramNative: true
                    }
                });
            }
        }
    };
    useEffect(() => {
        calcDate();
    }, []);
    console.log(titleUrl, jumpLink, 'titleUrl');
    return <Sensor once onAppear={() => handleAppera()} style={{
            width: '100%',
            height: '100%'
        }}>
            <View className="buy-tickets-container" onClick={() => handleClick()}>
                <ImageBackground source={{
            uri: bgImageURL
        }} className="buy-tickets-bg-image">
                    <View className="buy-tickets-content">
                        <View className="buy-tickets-content-title-container">
                            <View className="buy-tickets-content-title">
                                <Image source={{
            uri: titleUrl,
            width: 104,
            height: 24
        }} resizeMode="contain" className="buy-tickets-content-title-image"/>
                            </View>
                            <View className="buy-tickets-title-lunch">
                                <Text className="buy-tickets-title-lunch-text" style={{
            color: lunarDateConfig.lunarDateTextColor
        }}>
                                    {lunchText}
                                </Text>
                            </View>
                        </View>


                        <View className="buy-tickets-time">
                            {targetDate.split('')?.map((item, index) => {
            const isNumber = isNumberReg.test(item);
            return <View className="buy-tickets-time-cell" style={{
                    width: isNumber ? '36rpx' : !isNumber && index === 2 ? '32rpx' : '20rpx',
                    backgroundColor: isNumber ? gregorianDateConfig.gregorianDateBgColor : 'none',
                    marginRight: isNumber ? '3rpx' : '6rpx'
                }}>
                                        <Text style={{
                    width: '100%',
                    color: isNumber ? gregorianDateConfig.gregorianDateTextColor : '#000',
                    fontSize: isNumber ? '28rpx' : '24rpx',
                    fontFamily: isNumber ? 'MTNewDigitalDisplay-Bold' : 'PingFang SC',
                    fontWeight: isNumber ? "700" : "400",
                    lineHeight: isNumber ? '28rpx' : '24rpx',
                    textAlign: 'center',
                    paddingTop: isMRN && !isHarmony ? '10rpx' : 0
                }}>{item}</Text>
                                    </View>;
        })}
                        </View>
                        <View className="buy-tickets-button">
                            <LinearGradient className="buy-tickets-button-linear" start={{
            x: 0,
            y: 0
        }} end={{
            x: 1,
            y: 0
        }} colors={[buttonConfig.buttonBgColorStart || '#FF7F2F', buttonConfig.buttonBgColorEnd || '#FF2D19']}>
                                <Text className="buy-tickets-button-text" style={{
            color: buttonConfig.buttonTextColor || '#fff'
        }}>
                                    {buttonConfig.buttonText}</Text>
                            </LinearGradient>
                        </View>

                    </View>
                </ImageBackground>
            </View>
        </Sensor>;
};
export default memo(BuyTickets);
